import { Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import blankAS from "../img/blankAS.png";
import customAS from "../img/customAS.png";
import differencetable from "../img/differencetable.png";
import filters from "../img/filters.png";
import genericAS from "../img/genericAS.png";
import gtip1 from "../img/gtip1.png";
import gtip2 from "../img/gtip2.png";
import howitworks from "../img/howitworks.png";
import onlineAS from "../img/onlineAS.png";
import prefilledAS from "../img/prefilledAS.png";
import tip1 from "../img/tip1.png";
import tip2 from "../img/tip2.png";
import tip3 from "../img/tip3.png";
import tip4 from "../img/tip4.png";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  faqTopics: {
    paddingTop: "30px",
    backgroundColor: "#f7f7f7",
    "& li": {
      color: "#646f79",
      listStyleType: "none",
      margin: "0px 10px",
      fontWeight: "600",
      fontSize: "16px",
      padding: "10px 20px",
      [theme.breakpoints.down("xs")]: {
        marginLeft: "-20px",
      },
    },
    "& li:hover": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
      cursor: "pointer",
    },
    "& li.active": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
    },
  },
  faqWrapper: {
    marginTop: "34px",
    color: "#151b26",
    position: "sticky",
    height: `calc(100% )`,
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      position: "relative",
      borderBottom: "1px dashed black",
      marginRight: "15px",
      marginLeft: "15px",
    },
  },

  faqQuestions: {
    width: "100%",
    paddingTop: "50px",
    overflow: "auto",
    height: `calc(100vh)`,
    "&::-webkit-scrollbar": {
      display: "none",
    },
    padding: "20px",
    color: "#151b26",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      overflow: "visible",
    },
  },

  accordionRoot: {
    border: "none",
    boxShadow: "none",
    "&:before": {
      display: "none",
    },
    "& .Mui-expanded": {
      backgroundColor: "#F2F2F2",
    },
    "& .MuiCollapse-wrapper": {
      backgroundColor: "#F2F2F2",
    },
    "& .MuiAccordionSummary-root:hover": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
      cursor: "pointer",
    },
    "& .MuiAccordionSummary-root.Mui-expanded": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
      cursor: "pointer",
    },
    "& .MuiAccordionSummary-expandIcon.Mui-expanded": {
      color: "#9287FF",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
      borderRadius: "10px",
    },
  },
  fontHeading: {
    color: "#646f79",
    textDecoration: "underline",
    fontWeight: 700,
  },
  accordionImg: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
  },
  accordionImg2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  accordionImg3: {
    maxWidth: "250px",
    width: "80%",
    margin: "15px 20px 0px 20px",
    display: "block",
  },
  details: {
    maxWidth: "100ch",
  },
  imgExplainerText: {
    display: "list-item",
    listStyleType: "disc",
    listStylePosition: "inside",
    marginTop: "20px",
    fontWeight: "700",
  },
  hyperlink: {
    color: "#8277FF !important",
    textDecoration: "none",
  },
}));

function FaqWrapper({ children, selectedCategory, category }) {
  if (selectedCategory === "all" || category.includes(selectedCategory))
    return children;
  return null;
}

function Questions() {
  const [category, setCategory] = useState("all");

  const classes = useStyles();

  return (
    <>
      <div className="App">
        <Helmet>
          <title>Frequently Asked Questions About How SwiftGrade Works</title>
          <meta
            name="description"
            content="SwiftGrade helps teachers save time grading assessments. This means a stack of papers that would normally take a teacher one hour to grade can now be done in under 60 seconds."
          />
        </Helmet>
      </div>
      <div className={classes.root}>
        <Grid container style={{ minHeight: "100vh" }}>
          <Grid item xs={12} sm={3} className={classes.faqTopics}>
            <div className={classes.faqWrapper}>
              <Hidden smUp>
                <div>
                  <Typography variant="h4">
                    Frequently Asked Questions
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    style={{ maxWidth: "100ch", marginBottom: "30px" }}
                  >
                    Below you’ll find answers to the most Frequently Asked
                    Questions about SwiftGrade. For more detailed information
                    about how you can use SwiftGrade, visit our{" "}
                    <Link to="/" className={classes.hyperlink}>
                      Help Center.
                    </Link>
                  </Typography>
                </div>
              </Hidden>
              <ul id="topicList">
                <li
                  className={category === "all" ? "active" : ""}
                  onClick={(e) => setCategory("all")}
                >
                  All Topics
                </li>
                <li
                  className={category === "general" ? "active" : ""}
                  onClick={(e) => setCategory("general")}
                >
                  General
                </li>
                <li
                  className={category === "accuracy" ? "active" : ""}
                  onClick={(e) => setCategory("accuracy")}
                >
                  Handwriting Accuracy
                </li>
                <li
                  className={category === "answer" ? "active" : ""}
                  onClick={(e) => setCategory("answer")}
                >
                  Answer Sheets
                </li>
                <li
                  className={category === "functionality" ? "active" : ""}
                  onClick={(e) => setCategory("functionality")}
                >
                  Functionality
                </li>
                <li
                  className={category === "compatibility" ? "active" : ""}
                  onClick={(e) => setCategory("compatibility")}
                >
                  Device Compatibility
                </li>
                <li
                  className={category === "account" ? "active" : ""}
                  onClick={(e) => setCategory("account")}
                >
                  Account
                </li>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} sm={9} className={classes.faqQuestions}>
            <Hidden xsDown>
              <div>
                <Typography variant="h4">Frequently Asked Questions</Typography>
                <Typography
                  variant="subtitle2"
                  style={{ maxWidth: "100ch", marginBottom: "30px" }}
                >
                  Below you’ll find answers to the most Frequently Asked
                  Questions about SwiftGrade. For more detailed information
                  about how you can use SwiftGrade, visit our{" "}
                  <Link to="/" className={classes.hyperlink}>
                    Help Center.
                  </Link>
                </Typography>
              </div>
            </Hidden>
            <FaqWrapper category={["general"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What is SwiftGrade?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    SwiftGrade helps teachers save time grading assessments.
                    <br />
                    <br />
                    For paper assessments, SwiftGrade uses computer vision and
                    AI to read all the different variations of student
                    handwriting, including in different languages, and even
                    complex math formulas, to instantly generate results for the
                    teacher.
                    <br />
                    <br />
                    This means a stack of papers that would normally take a
                    teacher one hour to grade can now be done in under 60
                    seconds.
                    <br />
                    <br />
                    For online assessments, SwiftGrade uses intelligent
                    algorithms to grade student work.
                    <br />
                    <br />
                    Lastly, SwiftGrade grades just like a teacher naturally
                    would. For example, it can give part marks, allows a
                    tolerance range for numeric answers, and can even accept
                    minor spelling mistakes if the teacher wishes.
                    <br />
                    <br />
                    <span style={{ fontFamily: "Gordita-Medium" }}>
                      To learn a little bit more about our story, see this{" "}
                      <a
                        target="_blank"
                        href="https://gosolo.subkit.com/swiftgrade/"
                        class={classes.hyperlink}
                      >
                        {" "}
                        article
                      </a>{" "}
                      on SwiftGrade in the digital magazine MySolo.
                    </span>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["general"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    How does SwiftGrade work?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails display="block">
                  <div>
                    <Typography
                      className={classes.details}
                      display="block"
                      variant="body2"
                    >
                      SwiftGrade is based on answer sheets. <br />
                      <br />
                      In summary, teachers create an answer key, students
                      respond in our answer sheets, and then SwiftGrade compares
                      the two to generate results.
                      <br />
                      <br />
                      Note that you never input your test questions into
                      SwiftGrade. Instead, you only input your answers.
                      <br />
                      <br />
                      For more details, see the illustration below:
                    </Typography>
                    <br />

                    <img
                      alt="howitworks"
                      style={{ maxWidth: "600px" }}
                      className={classes.accordionImg}
                      src={howitworks}
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["accuracy"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    How accurate is SwiftGrade’s handwriting recognition?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    Our handwriting recognition, including the recognition of
                    math formulas is remarkably accurate. For neat handwriting,
                    our accuracy rate is around 98%. For messy writing,
                    unfortunately even giants like Google and Microsoft struggle
                    with accuracy.
                    <br />
                    <br />
                    However, we knew from day one that students write messily,
                    and we never designed SwiftGrade thinking that we would
                    achieve 100% accuracy. Instead, we designed SwiftGrade to
                    reduce your grading load for handwritten assessments by
                    80-90%.
                    <br />
                    <br />
                    The way this is done is that SwiftGrade flags answers with
                    ‘low recognition confidence’. You can easily filter to view
                    only these answers, and thus grade just a fraction of your
                    total grading load.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["accuracy"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Can I see which answers SwiftGrade struggled to read?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    Yes, in our results section we have a filters tool that
                    allows you to view only answers that were flagged as low
                    confidence, and thus needs manual grading.
                    <br />
                    <br />
                    As an example, if 20 students took a 20 question quiz,
                    that’s a total of 400 answers. Now if SwiftGrade flagged 40
                    answers, you only need to grade 10% of the original grading
                    load.
                    <br />
                    <br />
                    Here is a screenshot of our filters tool:
                    <img
                      style={{
                        boxShadow: "none",
                        backgroundColor: "transparent",
                        maxWidth: "425px",
                      }}
                      className={classes.accordionImg2}
                      src={filters}
                      alt="Filters"
                    />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper
              category={["compatibility"]}
              selectedCategory={category}
            >
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What's the difference between our Website and iOS/Android
                    app?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <Typography
                      className={classes.details}
                      display="block"
                      variant="body2"
                    >
                      Our website allows you to do everything except scan paper
                      answer sheets with your phone’s camera – for that you need
                      the SwiftGrade App.
                      <br />
                      <br />
                      Our App is mostly meant for quickly creating
                      multiple-choice answer keys, scanning paper answer sheets,
                      and viewing basic results on the fly.
                      <br />
                      <br />
                      For a detailed breakdown of our Website vs. App, see the
                      table below:
                    </Typography>
                    <img
                      src={differencetable}
                      style={{
                        maxWidth: "600px",
                        borderRadius: "0px",
                        width: "100%",
                      }}
                      className={classes.accordionImg2}
                    />
                    <Typography
                      className={classes.details}
                      display="block"
                      variant="body2"
                    >
                      We recommend that you use our website for everything but
                      scanning answer sheets.
                    </Typography>
                  </div>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper
              category={["functionality"]}
              selectedCategory={category}
            >
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3a-content"
                  id="panel3a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Do I need to create or upload my questions on SwiftGrade?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    No, you do not. SwiftGrade works independently of your
                    assessment questions. For example, your questions could be
                    written on your classroom’s whiteboard, be in a textbook, or
                    even in a video.
                    <br />
                    <br />
                    Therefore, with SwiftGrade you only need to input your
                    answers and then have students respond in our online or
                    paper answer sheets.
                    <br />
                    <br />A good analogy is Scantron forms. SwiftGrade can do so
                    much more than Scantron forms, but the underlying principle
                    of creating an answer key and having students respond in
                    answer sheets is the same.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["answer"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What are answer sheets?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    Answer sheets are where students input their answers to your
                    assessment questions.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["answer"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Can SwiftGrade answer sheets be printed on regular paper?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    Yes, our paper answer sheets can be printed on regular
                    paper. We recommend printing on large page sizes such as A4.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["answer"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What's the difference between our multiple-choice, written,
                    and online answer sheets?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <Typography
                      displau="block"
                      className={classes.details}
                      variant="body2"
                    >
                      <span style={{ textDecoration: "underline" }}>
                        1. Multiple-choice answer sheets (paper)
                      </span>{" "}
                      can be used with any assessment that is purely multiple
                      choice. This means that you can pre-print a stack of them
                      at the start of the school year and use them as needed.
                      <br />
                      <br />
                      Here is an example of a multiple-choice answer sheet:
                    </Typography>
                    <img
                      className={classes.accordionImg}
                      src={genericAS}
                      alt="Answer Sheet"
                    />
                    <Typography
                      displau="block"
                      className={classes.details}
                      variant="body2"
                    >
                      <span style={{ textDecoration: "underline" }}>
                        2. Written answer sheets (paper)
                      </span>{" "}
                      are generated based on your answer key. For example, if
                      you created a key with Q#1 as multiple choice and Q#2 as
                      fill in the blank, it would need a different answer sheet
                      than a key with both answers as fill in the blank.
                      <br />
                      <br />
                      Due to this, written answer sheets only work with the
                      assessment they were generated for.
                      <br />
                      <br />
                      Here is an example of a written answer sheet:
                    </Typography>
                    <img
                      className={classes.accordionImg}
                      src={customAS}
                      alt="Answer Sheet"
                    />
                    <Typography
                      displau="block"
                      className={classes.details}
                      variant="body2"
                    >
                      <span style={{ textDecoration: "underline" }}>
                        3. Online answer sheets (online)
                      </span>{" "}
                      can be released to students with just a few clicks. Once
                      released, students can then access them by logging in to
                      the SwiftGrade student portal on our website.
                      <br />
                      <br />
                      Example of an online answer sheet:
                    </Typography>
                    <img
                      style={{ maxWidth: "700px" }}
                      className={classes.accordionImg}
                      src={onlineAS}
                      alt="Answer Sheet"
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["answer"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What's the difference between our pre-filled and no-name
                    answer sheets?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    Paper answer sheets can be either ‘pre-filled’ or ‘no-name’.
                    <br />
                    <br />
                    <span
                      style={{ textDecoration: "underline", fontWeight: "700" }}
                    >
                      Pre-filled answer sheets
                    </span>{" "}
                    have student names pre-inputted into the sheets. This means
                    there will be one pre-filled sheet for each student in your
                    class. They also have student emails encoded in the barcode
                    of the answer sheets. This means you can always email
                    students their results.
                    <img
                      className={classes.accordionImg2}
                      src={prefilledAS}
                      alt="Custom Tip 1"
                    />
                    <br />
                    <br />
                    <span
                      style={{ textDecoration: "underline", fontWeight: "700" }}
                    >
                      No-name answer sheets
                    </span>{" "}
                    are not specific to any student. Students write their name
                    (and optionally their email) into the answer sheets. Only
                    students who write their email in the answer sheets will be
                    able to receive results.
                    <img
                      className={classes.accordionImg2}
                      src={blankAS}
                      alt="Custom Tip 1"
                    />
                    <br />
                    <br />
                    It is always a good idea that even if you use pre-filled
                    answer sheets to print a few extra no-name ones just in case
                    students make mistakes and need to start over with a fresh
                    answer sheet.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["general"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Is SwiftGrade meant for paper or online assessments?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    SwiftGrade can grade both paper and online assessments
                    making it great for virtual, in-person, or hybrid learning.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper
              category={["functionality"]}
              selectedCategory={category}
            >
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Do students need to join my class to take assessments?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    <span style={{ textDecoration: "underline" }}>
                      Paper assessments:
                    </span>{" "}
                    Students can take paper assessments without joining any of
                    your classes. However, if a student is not a part of your
                    class, you won’t be able to release results to them unless
                    they write their email address in their answer sheet.
                    <br />
                    <br />
                    <span style={{ textDecoration: "underline" }}>
                      Online assessments:
                    </span>{" "}
                    Students must be a part of your class to take online
                    assessments.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["accuracy"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What are tips to increase handwriting recognition accuracy?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <Typography
                      display="block"
                      className={classes.details}
                      variant="body2"
                    >
                      To reduce your amount of manual grading, please stress to
                      your students to:
                    </Typography>
                    <br />
                    <Typography
                      display="block"
                      className={classes.imgExplainerText}
                      variant="body2"
                    >
                      Write with large and neat characters:
                    </Typography>
                    <img
                      className={classes.accordionImg3}
                      src={tip3}
                      alt="Custom Tip 1"
                    />
                    <br />
                    <Typography
                      display="block"
                      className={classes.imgExplainerText}
                      variant="body2"
                    >
                      Print characters(do not write cursive):
                    </Typography>
                    <img
                      className={classes.accordionImg3}
                      src={tip1}
                      alt="Custom Tip 2"
                    />
                    <br />
                    <Typography
                      display="block"
                      className={classes.imgExplainerText}
                      variant="body2"
                    >
                      Write inside the box:
                    </Typography>
                    <img
                      className={classes.accordionImg3}
                      src={tip2}
                      alt="Custom Tip 3"
                    />
                    <br />
                    <Typography
                      display="block"
                      className={classes.imgExplainerText}
                      variant="body2"
                    >
                      Completely erase mistakes:
                    </Typography>
                    <img
                      className={classes.accordionImg3}
                      src={tip4}
                      alt="Custom Tip 4"
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["accuracy"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What are tips to increase multiple-choice recognition
                    accuracy?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <Typography
                      display="block"
                      className={classes.details}
                      variant="body2"
                    >
                      To maximize grading accuracy, please tell students to:
                    </Typography>
                    <br />
                    <Typography
                      display="block"
                      className={classes.imgExplainerText}
                      variant="body2"
                    >
                      Fill circles fully:
                    </Typography>
                    <img
                      style={{ maxWidth: "400px" }}
                      className={classes.accordionImg3}
                      src={gtip1}
                      alt="Custom Tip 1"
                    />
                    <br />
                    <Typography
                      display="block"
                      className={classes.imgExplainerText}
                      variant="body2"
                    >
                      Use dark color pen or pencil:
                    </Typography>
                    <img
                      style={{ maxWidth: "250px" }}
                      className={classes.accordionImg3}
                      src={gtip2}
                      alt="Custom Tip 2"
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper
              category={["functionality"]}
              selectedCategory={category}
            >
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Can students show their work with SwiftGrade?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    Currently SwiftGrade does not have room for students to show
                    their work on our answer sheets. However, this is a feature
                    we plan to add in the future.
                    <br />
                    <br />
                    We know it is not ideal, but for now you can have students
                    show their work on a separate piece of paper and input only
                    their final answer in our answer sheets.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper
              category={["functionality"]}
              selectedCategory={category}
            >
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Does SwiftGrade support free response answers?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    Currently SwiftGrade does not support free response answers,
                    but it is a feature we plan to add in the future.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper
              category={["compatibility", "general"]}
              selectedCategory={category}
            >
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Is there a SwiftGrade app for students?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    No, the SwiftGrade App is only for teachers. However,
                    students can access SwiftGrade through the student portal on
                    our website.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["general"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    What subjects is SwiftGrade for?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    SwiftGrade is not subject specific - we have teachers from a
                    variety of subjects and grade levels using SwiftGrade for
                    their summative and formative assessment needs.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["account"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    Do you offer group pricing or plans to teachers or schools?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    For school and district licenses, please contact us at{" "}
                    <a
                      href="mailto:sales@goswiftgrade.com"
                      className={classes.hyperlink}
                    >
                      sales@goswiftgrade.com.
                    </a>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
            <FaqWrapper category={["account"]} selectedCategory={category}>
              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                  className={classes.accordionSummary}
                >
                  <Typography className={classes.fontHeading}>
                    How do I delete my account?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={classes.details} variant="body2">
                    To delete your account and all of your content, please email
                    us at{" "}
                    <a
                      href="mailto:support@goswiftgrade.com"
                      className={classes.hyperlink}
                    >
                      support@goswiftgrade.com.
                    </a>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </FaqWrapper>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default Questions;
